import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import type { MemberEntityScope } from 'features/users';

export const useNavigateToMembersEntities = () => {
  const navigate = useNavigate();

  return useCallback(
    async (memberId: string, scope: MemberEntityScope) => {
      await navigate(routes.members.entities(memberId, scope));
    },
    [navigate],
  );
};
